import { all, takeLatest } from '@redux-saga/core/effects';
import { PACKAGES_REQUEST, PACKAGE_PURCHASE_REQUEST } from '../../redux/packages/types';
import packagesRequest from './packagesRequest';
import purchaseRequest from './purchaseRequest';

export default function*() {
    yield all([takeLatest(PACKAGES_REQUEST, packagesRequest), takeLatest(PACKAGE_PURCHASE_REQUEST, purchaseRequest)]);
}
